import { Badge } from "~/components/Badge";
// import { LoadingSpinner } from "~/components/LoadingSpinner";
// import { getBadgeClassName } from "~/components/Badge/component";
// import { cn } from "~/lib/utils";

// // // //

/**
 * ResultCountDisplay
 * Displays a loading spinner and the number of results for a given query
 */
export function ResultCountDisplay(props: {
    loading: boolean;
    defaultVariant?: "blue" | "green";
    resultCount: number;
}) {
    const { loading, defaultVariant = "green", resultCount } = props;

    const variant = resultCount > 0 ? defaultVariant : "yellow";

    const resultLabel = "Total";

    const text =
        resultCount > 0
            ? `${resultCount.toLocaleString()} ${resultLabel}`
            : "No Results";

    return <Badge label={text} variant="blue" />;

    // return (
    //     <div
    //         className={getBadgeClassName({
    //             variant,
    //             size: "lg",
    //             rounded: "full",
    //             className: "justify-center text-center transition-colors",
    //         })}
    //     >
    //         {/* {loading && <LoadingSpinner show={loading} size={4} variant={variant} />} */}
    //         {/* <div className={!loading ? "opac" : ""}> */}
    //         <div
    //             className={cn("transition-opacity opacity-0", {
    //                 "opacity-100": loading,
    //             })}
    //         >
    //             <LoadingSpinner size={4} variant={variant} />
    //         </div>
    //         {loading && (
    //             <span className="min-w-24 whitespace-nowrap">Loading...</span>
    //         )}
    //         {!loading && (
    //             <span className="min-w-24 whitespace-nowrap">{text}</span>
    //         )}

    //         {/* Render placeholder to prevent layout shift */}
    //         <div className="invisible w-4 h-4 min-h-4 min-w-4" />
    //     </div>
    // );
}
